
























































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import CProdMixin from "@/mixins/cProdMixin";
import Context from "@/mixins/context";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IContractProduct } from "@/models/contracts";
import { IBlueprintField } from "@/models/provisioning";
import { IRoute } from "@/models/routes";

@Component({
  computed: {
    ...mapState({
      contractProductFieldsScope(state, getters) {
        return getters[
          `data/${DataModules.PROVISIONING_CONTRACT_PRODUCTS}/contractProductFieldsScope`
        ](this.contractId, this.productId);
      },
      contractProductFields(state, getters) {
        return (
          getters[`data/listArray`]({
            storeModule: DataModules.PROVISIONING_CONTRACT_PRODUCTS,
            scope: this.contractProductFieldsScope
          }) || []
        );
      }
    })
  },
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue")
  }
})
export default class CProdWithFieldsGridItem extends Mixins(
  Context,
  CProdMixin
) {
  // Map state

  public contractProductFields!: IBlueprintField[];
  public contractProductFieldsScope!: string;

  // Props

  @Prop({ default: undefined })
  public readonly cProd!: IContractProduct;

  @Prop({ default: false })
  public readonly isLoading!: boolean;

  // Data

  public loading = true;

  // Life-cycle methods

  public async created() {
    this.loadData();
  }

  public beforeDestroy() {
    this.$store.dispatch("data/binList", {
      storeModule: DataModules.PROVISIONING_CONTRACT_PRODUCTS,
      scope: this.contractProductFieldsScope,
      vm: this
    });
  }

  // Methods

  public async loadData() {
    try {
      await this.getContractProductFields();
    } catch (error) {
      // Silently erroring
    } finally {
      this.loading = false;
    }
  }

  public getContractProductFields(ignoreStored = false) {
    return this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONTRACT_PRODUCTS}/listContractProductFields`,
      {
        contractId: this.cProd.contract_id,
        productId: this.cProd.id,
        scope: this.contractProductFieldsScope,
        vm: this,
        ignoreStored
      }
    );
  }

  // Computed

  public get clientId() {
    return this.cProd.client_id;
  }

  public get fieldNames() {
    return _.map(
      _.orderBy(
        this.contractProductFields,
        ["required", "order"],
        ["desc", "asc"]
      ),
      ({ field_label }) => field_label.toString().toLocaleLowerCase()
    );
  }

  public get firstField() {
    return this.fieldNames[0];
  }

  public get secondField() {
    return this.fieldNames[1];
  }

  public get cProdClient() {
    return this.cProd?.clients?.[0];
  }

  public get cProdSetupRoute() {
    return this.$store.getters[
      `data/${DataModules.CONTRACTS_PRODUCTS}/routeToSetup`
    ](this.cProd)?.to as IRoute["to"];
  }

  public get iconBindings() {
    const request = _.first(this.cProd?.unresolved_provision_requests);
    if (!request) return {};
    return {
      icon: "exclamation-triangle",
      iconLabel: [request.function_name, request.result_message].join(": "),
      iconRouterLink: this.cProdSetupRoute,
      iconType: "is-danger"
    };
  }
}
